import { memo } from "react";
import { Text } from "../../../../packages/ui-kit";
import { helpers } from "../../../../packages/helpers";
import { ChatMessageReply } from "./chat-message-reply";
import { File } from "./partials";
import type { MessageFile } from "../../types";
import styles from "./message-kinds.module.scss";

const { linkInText } = helpers.text;

type Props = {
  dataTestId?: string;
  className?: string;
  message: MessageFile;
};

export const ChatMessageFile = memo(
  ({
    dataTestId = "message-content-file-container",
    className,
    message,
  }: Readonly<Props>) => {
    const { text, file } = message.content;

    const replyMessage = (
      <ChatMessageReply parentId={message.id} message={message.replyMessage} />
    );

    const textComponent = (
      <Text
        dataTestId="message-content-text"
        className={styles["message-text"]}
      >
        {/* TODO удалить при реализации entity*/}
        <span dangerouslySetInnerHTML={{ __html: linkInText(text) }} />
      </Text>
    );

    const fileComponent = (
      <File traceId={message.traceId} content={message.content} />
    );

    return (
      <div data-test-id={dataTestId} className={className}>
        {replyMessage}
        {!!text ? textComponent : null}
        {!!file ? fileComponent : null}
      </div>
    );
  }
);
